export default __webpack_public_path__ + "static/media/a011-PPII-1.8d1a7ee3.svg";